import { useQuery } from 'react-query';
import { apiService } from '~services/ApiService';
import { useUserStore } from '~providers/userStore/zustand';

interface BlockStatusResponse {
  is_blocked: boolean;
  blocked_date?: string;
  reason?: string;
}

export function useGetBlockStatus(targetUserId: string) {
  const currentUserId = useUserStore.getState().user?.uid;

  return useQuery<BlockStatusResponse>(
    ['blockStatus', currentUserId, targetUserId],
    async () => {
      if (!currentUserId || !targetUserId) {
        throw new Error('User IDs not available');
      }

      return await apiService.getWithParams<BlockStatusResponse>('users/is/blocked', {
        blocker_id: currentUserId,
        blocked_id: targetUserId,
      });
    },
    {
      enabled: !!currentUserId && !!targetUserId && currentUserId !== targetUserId,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      retry: false,
    }
  );
}
